const translations = {
  "en": {
    "--": "--",
    "✓ Tracked": "✓ Tracked",
    "cron": "cron",
    "event": "event",
    "Next schedule": "Next schedule",
    "once": "once",
    "Start tracking": "Start tracking",
    "Trigger action": "Trigger action"
  },
  "zh-tw": {
    "--": "請提供需要翻譯的英文原文。",
    "✓ Tracked": "✓ 已追蹤",
    "cron": "排程",
    "event": "事件",
    "Next schedule": "下次排程",
    "once": "一次",
    "Start tracking": "開始追蹤",
    "Trigger action": "觸發動作"
  }
};

export default translations;
